import {gql, useQuery} from '@apollo/client'

const useAllUsers = (vars = {}) => {
    return useQuery(
        gql`
            query (
                $state: Boolean
                $sortField: String
                $previous: String
                $next: String
                $limit: Int
                $roles: [Roles!]
                $search: String
            ) {
                allUsers (
                    state: $state
                    sortField: $sortField
                    previous: $previous
                    next: $next
                    limit: $limit
                    roles: $roles
                    search: $search
                ) {
                    docs {
                        id
                        firstName
                        lastName
                        avatar
                        educatorInfo {
                            googleCalendar
                            googleCalendarId
                        }
                    }
                }
            }
        `, {variables: vars}
    )
}

export default useAllUsers